





























import { index, destroy } from '@/api/asks'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    include: 'ask_category',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'question', label: 'Question' },
      { prop: 'category', label: 'Category', slot: true },
      { prop: 'created_at', label: 'Created time', width: 150 }
    ]
  }

  async destroyRow (row: Record<string, any>) {
    this.$ask(async () => {
      await destroy(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been deleted')
    })
  }
}
